import { Card } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemDetailsLayoutStyled = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`
